import { render, staticRenderFns } from "./articoloGenerico.vue?vue&type=template&id=11bda0a7&"
import script from "./articoloGenerico.vue?vue&type=script&lang=js&"
export * from "./articoloGenerico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports